import { Typography, Box, Grid, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { IPrice } from 'services/api/entities/stripe/price';

const DEFAULT_CURRENCY = 'usd';
const DEFAULT_PRICE = '0';

type Props = {
  price: IPrice | null;
};

const PriceTag = ({ price }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const currency = price ? price.currency : DEFAULT_CURRENCY;
  const productPrice = price ? price?.monthlyIntValue() : DEFAULT_PRICE;

  return (
    <Grid container direction="row" justifyContent="start">
      <Typography
        sx={{
          color: theme.palette.grey[50],
          fontSize: 40,
          lineHeight: 1,
          letterSpacing: 1,
          fontWeight: 500,
        }}
        variant="h3"
      >
        {t(`currency:${currency}`)}
        {productPrice}
      </Typography>

      <Box display="flex" flexDirection="column" justifyContent="end">
        <Typography
          variant="h5"
          sx={{
            fontSize: 16,
            color: theme.palette.grey[400],
            fontWeight: 300,
            lineHeight: 1,
            [theme.breakpoints.down('sm')]: {
              letterSpacing: '0.3px',
            },
          }}
        >
          {`/ ${t('subscription:priceTag:monthly')}`}
        </Typography>
      </Box>
    </Grid>
  );
};

export default PriceTag;
